<template>
    <div class="ui-switch inline-flex items-center">
        <span
            v-if="isLabelsExists"
            :class="['ui-switch__label text pointer', {unchecked: isSwitchChecked}]"
            @click="isSwitchChecked = false"
        >
            {{ switchLabels[0] }}
        </span>
        <input
            ref="ui-switch"
            v-model="isSwitchChecked"
            type="checkbox"
            class="ui-switch-button pointer"
        >
        <span
            v-if="isLabelsExists"
            :class="['ui-switch__label text pointer', {unchecked: !isSwitchChecked}]"
            @click="isSwitchChecked = true"
        >
            {{ switchLabels[1] }}
        </span>
    </div>
</template>

<script>
import {computed, defineComponent, ref, watch} from 'vue';

export default defineComponent({
    name: 'UISwitch',
    props: {
        switchLabels: {
            type: Array,
            default: () => ([]),
            validator: (value) => {
                return [0, 2].includes(value.length);
            },
        },
    },
    emits: ['switch'],
    setup(props, context) {
        const isSwitchChecked = ref(false);

        const isLabelsExists = computed(() => {
            return props.switchLabels?.length === 2 ?? false;
        });

        watch(isSwitchChecked, (newVal) => {
            context.emit('switch', newVal);
        });

        return {
            isSwitchChecked,
            isLabelsExists,
        };
    },
});
</script>

<style lang="scss" scoped>
@import '@/assets/styles/ui-elements/ui-switch';
</style>
